import { getFilterChips } from '../../search/filterChips'

let lastChips = []

export function setLastImpactfulChips(filterChips) {
    lastChips = getInterestingChips(filterChips)
}

export function getSearchExtra() {
    const interestingChips = getInterestingChips()

    return {
        impact: !!interestingChips.length,
        change: lastChips.length !== interestingChips.length,
    }
}

function getInterestingChips(filterChips) {
    return (filterChips?.length ? filterChips : getFilterChips()).filter(
        (f) => !!f && (typeof f.label !== 'string' || !f.label.includes('nchored'))
    )
}
